import './DatePickerVender.css';
import './DatePicker.sass';

import React, { Suspense, useState, lazy, FC, useEffect } from 'react';

import { DatePickerProps, DateRangePickerProps } from './DatePicker.interface';
import { IcCalendar28 } from '$assets';
import { useCurrentLang } from '$hooks';
import { retry } from '$utils';
const DatePickerVendor = lazy(() =>
  retry(() => import('react-datepicker/dist/react-datepicker.min.js')),
) as any;

export const DateRangePicker: FC<DateRangePickerProps> = (props) => {
  const [dateRange, setDateRange] = useState([props.startDate, props.endDate]);
  const [startDate, endDate] = dateRange;
  const { key: locale } = useCurrentLang();

  useEffect(() => {
    const localeMap = {
      en: () => import(`date-fns/locale/en-US`),
      ru: () => import(`date-fns/locale/ru`),
      id: () => import(`date-fns/locale/id`),
    };

    Promise.all([
      import('./DatePickerRegisterLocale'),
      localeMap[locale] ? localeMap[locale]() : localeMap.en(),
    ]).then(([{ default: registerLocale }, { default: l }]) => {
      registerLocale(locale, l);
    });
  }, [locale]);

  return (
    <Suspense fallback={<div className="DateRangePicker" />}>
      <div className="DateRangePicker">
        <DatePickerVendor
          {...props}
          locale={locale}
          className="DateRangePicker__input"
          startDate={startDate}
          endDate={endDate}
          isClearable={false}
          dateFormat="dd MMM yyyy"
          onChange={(update, e) => {
            setDateRange(update);
            if (update[1] && props.onChange) {
              // @ts-ignore
              props.onChange(update, e);
            }
          }}
          withPortal={!props.isDesktop}
          portalId="date-picker-portal"
          selectsRange={true}
        />
        <div className="DateRangePicker__icon">
          <IcCalendar28 />
        </div>
      </div>
    </Suspense>
  );
};

export const DatePicker: FC<DatePickerProps> = (props) => {
  const [selected, setSelected] = useState(props.selected);
  const { key: locale } = useCurrentLang();

  useEffect(() => {
    const localeMap = {
      en: () => import(`date-fns/locale/en-US`),
      ru: () => import(`date-fns/locale/ru`),
      id: () => import(`date-fns/locale/id`),
    };

    Promise.all([
      import('./DatePickerRegisterLocale'),
      localeMap[locale] ? localeMap[locale]() : localeMap.en(),
    ]).then(([{ default: registerLocale }, { default: l }]) => {
      registerLocale(locale, l);
    });
  }, [locale]);

  return (
    <Suspense fallback={<div className="DatePicker" />}>
      <div className="DatePicker">
        <DatePickerVendor
          {...props}
          locale={locale}
          className="DatePicker__input"
          selected={selected}
          isClearable={false}
          dateFormat="dd MMM yyyy"
          onChange={(update, e) => {
            setSelected(update);
            props.onChange(update, e);
          }}
          withPortal={!props.isDesktop}
          portalId="date-picker-portal"
        />
        <div className="DatePicker__icon">
          <IcCalendar28 />
        </div>
      </div>
    </Suspense>
  );
};
